import ColumnText from "../molecules/ColumnText";
import { Fragment } from "react";
import { Empty } from "./Empty";
import { t } from "i18next";

type optionsSalasProps = {
  id: number;
  name: string;
  description: string;
  color: string;
};

export type TableListSalasProps = {
  optionsSalas: optionsSalasProps[];
  onEdit?: (room: any) => void;
  onDelete?: (room: any) => void;
  canDelete?: boolean;
  canEdit?: boolean;
};

const TableListSalas: React.FC<TableListSalasProps> = ({
  optionsSalas = [],
  onEdit,
  canEdit,
}) => {
  return (
    <div className="">
      <div className="border-b border-gray-300 mt-5"></div>
      <div className="flow-root">
        {/* Añadir un contenedor con scroll */}
        <div className="overflow-x-auto max-h-[60vh]">
          <div className="inline-block min-w-full align-middle">
            {optionsSalas.length === 0 ? (
              <Empty texto={t("lesson.views.no_rooms")} />
            ) : (
              <Fragment>
                <table className="min-w-full divide-y divide-gray-300">
                  <thead>
                    <tr>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.name")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.description")}
                      </th>
                      <th
                        scope="col"
                        className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                      >
                        {t("lesson.views.color")}
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {optionsSalas.map((Salas) => (
                      <tr key={Salas.id}>
                        <ColumnText title={Salas.name} />
                        <ColumnText
                          title={Salas.description}
                          className="max-w-[200px]"
                          wrap
                        />

                        <td className="whitespace-nowrap px-3 py-5 text-sm text-gray-500">
                          <div
                            style={{ backgroundColor: Salas.color }}
                            className="w-8 h-8 rounded-sm inline-block mr-2"
                          ></div>
                        </td>
                        <td className="relative whitespace-nowrap py-5 pl-3 pr-4 text-right text-sm font-medium sm:pr-0">
                          {canEdit && (
                            <a
                              onClick={() => {
                                if (onEdit) {
                                  onEdit(Salas);
                                }
                              }}
                              href="#"
                              className="text-primary-600 hover:text-primary-900 mr-4"
                            >
                              {t("general.edit")}
                              <span className="sr-only"></span>
                            </a>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </Fragment>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default TableListSalas;
